export default __webpack_public_path__ + "static/media/C46361AD-1281-4B4F-A60B-77920A7B7970_1_105_c.f381b8c0.jpg";